customElements.get("dbtfy-cart-discount") || customElements.define(
  "dbtfy-cart-discount",
  class extends HTMLElement {
    constructor() {
      super();
      // Retrieves the component configuration data
      this.data = Debutify.widgets["dbtfy-cart-discount"];

      // Sets the icon based on the configuration data
      this.querySelector(".delivery-label-icon i").setAttribute(
        "data-icon",
        this.data.dbtfy_cart_discount_label_icon
      );

      // DOM references
      this.discountRows = document.querySelectorAll(".dbtfy-cart-discount__discounts");
      this.discountNotification = this.querySelector(".dbtfy-discount-notification");
      this.loadingSpinner = this.querySelector(".dbtfy-cart-discount__spinner");

      // State variables
      this.discounts = {};
      this.isLoading = false;

      this.init();
    }

    init() {
      const button = this.querySelector(".dbtfy-cart-discount__button");
      const input = this.querySelector(".dbtfy-cart-discount__input");

      // Button handle onClick
      button.onclick = () => {
        const inputCode = this.querySelector("input").value;
        if (inputCode !== "" && !this.isLoading) {
          this.addDiscount(inputCode);
        }
      };

      // Add keydown event listener to the input field
      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault(); // Prevent default form submission
          button.click(); // Trigger the button click
        }
      });

      // Fetch the cart discounts
      this.initFetchDiscounts();
    }

    addDiscount(newDiscountCode) {
      // Set loading state
      this.setLoading(true);

      // Check if the discount already exists
      const discountExists = this.discounts.some(
        (discount) => discount.code.toLowerCase() === newDiscountCode.toLowerCase()
      );

      // Show error if the discount already exists
      if (discountExists) {
        this.showNotification('Finns redan');
        this.setLoading(false);
        return;
      }

      const mergedCodes = [...this.discounts.filter(d => d.type === 'code').map(d => d.code), newDiscountCode].filter(Boolean).join(',');

      // Post the discount code to Shopify's cart update API
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: mergedCodes })
      })
        .then(response => response.json())
        .then(data => {
          const foundDiscounts = data?.cart_level_discount_applications;

          if (foundDiscounts) {
            // Find the code that was just attempted
            const appliedDiscount = foundDiscounts.find(
              alloc => alloc.discount_application.title.toLowerCase() === newDiscountCode.toLowerCase()
            );

            // Is it valid?
            if (appliedDiscount) {
              this.showNotification('Tillagd');

              // Append to discounts list
              this.discounts.push({
                code: appliedDiscount.discount_application.title,
                amount: this.formatMoney(appliedDiscount.discount_application.value),
                type: 'code'
              });

              // Refresh discounts badges
              this.renderFrontend();
            } else {
              this.showNotification('Ogiltig');
            }

            this.setLoading(false);
          }
        })
        .catch(error => {
          console.error("dbtfy-cart-discount: Error applying discount:", error);
        });
    }

    removeDiscount(discountCode) {
      this.setLoading(true);

      // Filter out the discount to be removed (only for type === 'code')
      this.discounts = this.discounts.filter(
        (discount) => !(discount.type === 'code' && discount.code.toLowerCase() === discountCode.toLowerCase())
      );

      // Prepare the updated discount codes
      const updatedCodes = this.discounts
        .filter((discount) => discount.type === 'code')
        .map((discount) => discount.code)
        .join(',');

      // Update the Shopify cart with the new discount codes
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: updatedCodes })
      })
        .then(response => response.json())
        .then(data => {
          const discounts = data?.discount_codes;

          if (discounts) {
            // Refresh the badges after removing the discount
            this.renderFrontend();
            this.showNotification('Borttagen');
          } else {
            this.showNotification('Fel uppstod');
          }

          this.setLoading(false);
        })
        .catch((error) => {
          console.error('dbtfy-cart-discount: Error removing discount:', error);
          this.showNotification('Fel uppstod');
          this.setLoading(false);
        });
    }

    initFetchDiscounts() {
      // Fetch current cart data as JSON
      fetch(`${window.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cartData) => {
          // Reset mappings for each fetch
          this.discounts = [];

          // Parse code discounts
          const codeDiscounts = cartData.cart_level_discount_applications || [];

          if (codeDiscounts.length > 0) {
            codeDiscounts.forEach((discount) => {
              // Is it applicable? (valid)
              if (discount.type === 'discount_code') {
                this.discounts.push({
                  code: discount.title,
                  amount: this.formatMoney(discount.value),
                  type: 'code'
                });
              }
            });
          }


          // Parse line items discount
          const lineItems = cartData.items || [];

          lineItems.forEach((item) => {
            const discounts = item.line_level_discount_allocations || [];

            if (discounts.length > 0) {
              // Store the full discount objects for this line item
              discounts.forEach((allocation) => {
                const discount = allocation.discount_application;

                if (discount.target_type === 'line_item') {
                  this.discounts.push({
                    code: discount.title,
                    amount: this.formatMoney(discount.total_allocated_amount / 100),
                    type: 'lineitem'
                  });
                }
              });
            }
          });

          // Render the badges based on our discounts
          this.renderFrontend();
        })
        .catch((error) => {
          console.error("dbtfy-cart-discount: Error fetching cart:", error);
        });
    }

    getIconByType(type) {
      switch (type) {
        case 'code':
          return 'local_offer';
        case 'lineitem':
          return 'inventory_2';
        default:
          return 'question_mark';
      }
    }

    renderFrontend() {
      // Render discount badges in each cart (popup and page)
      this.discountRows.forEach((discountRow) => {
        // Remove existing content
        discountRow.innerHTML = "";

        // Track which discounts have already been rendered so we don't
        // append duplicate badges when codes are reused across sources
        const renderedDiscounts = new Set();

        // Create a badge for each (unique) discount
        this.discounts.forEach((discount) => {
          const key = `${discount.type}:${String(discount.code).toLowerCase()}`;
          if (renderedDiscounts.has(key)) return;
          renderedDiscounts.add(key);

          const entry = document.createElement("span");
          entry.className = "dbtfy-discount-entry totals";

          // Get the appropriate icon for the discount type
          const icon = this.getIconByType(discount.type);

          entry.innerHTML = `
            <span style="font-size:0.9em;">
              <i class="material-icon outlined dbtfy-discount-badge__icon" data-icon="${icon}"></i>
              ${discount.code}

              ${discount.type === "code" ?
            `<button class="dbtfy-cart-discount__remove" data-discount-code="${discount.code}" aria-label="Ta bort rabattkod">
                  <i class="material-icon outlined dbtfy-discount-badge__icon" data-icon="delete"></i>
                </button>`
            : ''}
            </span>

            <span style="text-align:right;font-size:1em;">
              ${discount.amount} SEK
            </span>
          `;

          // Append the entry to the discount row
          discountRow.appendChild(entry);

          // Add click event listener to the remove button if it exists
          const removeButton = entry.querySelector(".dbtfy-cart-discount__remove");

          if (removeButton) {
            removeButton.addEventListener("click", () => {
              const discountCode = removeButton?.getAttribute("data-discount-code");
              if (discountCode) this.removeDiscount(discountCode);
            });
          }
        });
      });

      // Calculate total discount amount
      const totalDiscount = this.discounts.reduce((total, discount) => {
        return total + Number(discount.amount.replace(/\s/g, ''));
      }, 0);

      // Update cart save amount
      const cartSavingRows = document.querySelectorAll('.dbtfy-cart-saving--value');

      cartSavingRows.forEach((cartSavingRow) => {


        cartSavingRow.textContent = this.formatMoney(totalDiscount) + ' SEK';
        const parent = cartSavingRow.parentElement;

        if (totalDiscount === 0) {
          if (parent && !parent.classList.contains('hidden')) {
            parent.classList.add('hidden');
          }
        } else {
          if (parent && parent.classList.contains('hidden')) {
            parent.classList.remove('hidden');
          }
        }
      });

      // Update total amount
      const totalRows = document.querySelectorAll('.totals__total-value');

      totalRows.forEach((totalRow) => {
        const total = totalRow.dataset.total / 100;
        const newTotal = total - totalDiscount;

        totalRow.innerText = this.formatMoney(newTotal) + ' SEK';
      });

      // Checkout button
      const checkoutBtns = document.querySelectorAll('.cart__checkout-button__text');

      checkoutBtns.forEach((btn) => {
        const total = btn.dataset.total / 100;
        const newTotal = total - totalDiscount;

        btn.innerText = `Till kassan — ${this.formatMoney(newTotal)} SEK`;
      });
    }

    showNotification(message) {
      // Set the notification content and ensure it is visible
      this.discountNotification.textContent = message;
      this.discountNotification.classList.remove('hidden');

      // Auto-hide after a short delay
      clearTimeout(this._notificationTimeout);
      this._notificationTimeout = setTimeout(() => {
        this.discountNotification.classList.add('hidden');
      }, 4000);
    }

    formatMoney(amount) {
      amount = Math.round(Number(amount));
      return amount.toLocaleString('sv-SE');
    }

    setLoading(state) {
      this.isLoading = state;

      if (state) {
        this.loadingSpinner.classList.remove('hidden');
      } else {
        this.loadingSpinner.classList.add('hidden');
      }
    }
  }
);
